<template>
  <div class="searchKeyword__filter form">
    <label
      for="searchKeyword"
      class="section-heading"
    >
      {{ keywordLabel }}
    </label>

    <input
      id="searchKeyword"
      v-model="internalKeyword"
      type="search"
      :maxlength="searchQueryMaxLength"
      :placeholder="placeholder"
      data-hj-allow
      @change="$emit('onSearchKeywordChange', internalKeyword)"
    >
  </div>
</template>

<script src="./index.js"></script>

<style scoped lang="scss">
    @import './style.scss';
</style>
